import React from "react";
import { PuffLoader } from "react-spinners";
import { LengthType } from "react-spinners/helpers/props";
import { BlankString } from "../Constants";

type LoaderProps = {
  size?: LengthType | undefined,
  loading?: boolean | undefined,
  loadingMessage?: string | undefined
};

export default function Loader(loaderProps: LoaderProps) {
  const spinnerStyleOverride = { display: "inline-flex", verticalAlign: "middle", marginLeft: "10px" };
  if(loaderProps.loadingMessage === undefined){
    return(
      <PuffLoader color="#dc9832" size={loaderProps.size} cssOverride={spinnerStyleOverride} loading={loaderProps.loading} />
    );
  }
  return(
    <div style={{textAlign: "center", paddingTop: 10}} className={loaderProps.loading ? BlankString : "hide"}>
      <PuffLoader color="#dc9832" size={loaderProps.size} cssOverride={spinnerStyleOverride} loading={loaderProps.loading} />
      <h2>{loaderProps.loadingMessage}</h2>
    </div>
  );
};